import React, { useEffect, useState } from "react";
import { Topbar, EmptyCard } from "@components";
import {
  RootContainer,
  RefreshIcon,
  Top,
  LightText,
  Text,
  ListContainer,
  ListWrapper,
  ListItem,
  ItemText,
  DateText,
  AmountText,
  StatusText,
  Wrapper,
  Image,
  // BottomImage,
  // Bottom,
  LogoImage,
  ImageWrapper,
  SpinWrapper,
  Container,
  MyWalletContainer,
  MyWalletLabel,
  ActionContainer,
  RecentHistoryTitle,
  SellAllWrapper,
  Subtitle,
  Sublabel,
  SubContainer,
  LightTextContainer,
  BonusStatusText,
  ExpiredContainer,
  ExpiredText,
} from "./Wallet.style";
import { useNavigate, useLocation } from "react-router-dom";
import { PRIVATE_ROUTE, PUBLIC_ROUTE } from "@router/route.constants";
import { Button, Spin } from "antd";
import { TOPUP_LK, WITHDRAW_SK, BONUS_SK } from "@constants";
import { useDispatch, useSelector } from "react-redux";
import { getFormattedNumber, localStorage } from "@utils";
import { api } from "@api";
import moment from "moment";
import { saveUser } from "@redux/auth/authSlice";
import { useTranslation } from "react-i18next";
import { getStatus, getUseOrNotUse } from "@utils";
import { AddCircleFill, UploadFill, DotFill, BalanceLoading } from "@assets";
import Lottie from "react-lottie";

const dateFormat = "MMM DD, YYYY hh:mm:ss A";

export const BonusImage = () => (
  <ImageWrapper>
    <LogoImage />
  </ImageWrapper>
);

const WalletButton = ({ label, icon, onClick }) => {
  return (
    <MyWalletContainer onClick={onClick}>
      <MyWalletLabel>{label}</MyWalletLabel>
      {icon}
    </MyWalletContainer>
  );
};

const Wallet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { main_balance, bonus, is_in_game } = useSelector(
    (state) => state.auth.user
  );
  // const ads = useSelector((state) => state.app.settings.app_carousel)[0];
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    getRecentHistory();

    // eslint-disable-next-line
  }, []);

  const getRecentHistory = () => {
    setLoading(true);
    api
      .getRecentHistory()
      .then(({ transactions, user }) => {
        setLoading(false);
        setData(transactions);

        // Save user to redux
        dispatch(saveUser(user));
        // Set user to localstorage
        localStorage.setUser(user);
      })
      .catch((error) => { });
  };

  const goBack = () => {
    if (!state) {
      navigate(`/${PUBLIC_ROUTE.HOME}`);
    } else {
      navigate(state.back);
    }
  };

  const goToTransactions = () => {
    navigate(`/${PRIVATE_ROUTE.TRANSACTIONS}`);
  };

  const handleTopUpClicked = () => {
    navigate(`/${PRIVATE_ROUTE.ACCOUNT_TYPE}/${TOPUP_LK}`);
  };

  const handleWithdrawClicked = () => {
    navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`);
  };

  const refresh = () => {
    window.location.reload();
  };

  const renderTop = () => (
    <Top>
      <LightText>{t("wallet.walletTotalBalance")}</LightText>
      <LightTextContainer>
        <Text>
          {is_in_game ? (
            <Lottie
              options={{
                animationData: BalanceLoading,
              }}
              height={36}
            />
          ) : (
            `${getFormattedNumber(main_balance + bonus)} Ks`
          )}
        </Text>
      </LightTextContainer>
      <SubContainer>
        <DotFill />
        <Subtitle>{t("wallet.actualTopBalance")}</Subtitle>
        <Sublabel>{`${is_in_game ? "-" : getFormattedNumber(main_balance)
          } Ks`}</Sublabel>
      </SubContainer>
      <SubContainer>
        <DotFill />
        <Subtitle>{t("wallet.bonusBalance")}</Subtitle>
        <Sublabel>{`${is_in_game ? "-" : getFormattedNumber(bonus)
          } Ks`}</Sublabel>
      </SubContainer>
    </Top>
  );

  const Actions = () => (
    <ActionContainer>
      <WalletButton
        icon={<AddCircleFill />}
        label={t("wallet.walletTopUp")}
        onClick={handleTopUpClicked}
      />
      <WalletButton
        icon={<UploadFill />}
        label={t("wallet.walletWithdraw")}
        onClick={handleWithdrawClicked}
      />
    </ActionContainer>
  );

  const Loader = () => (
    <SpinWrapper>
      <Spin />
    </SpinWrapper>
  );

  const List = () => (
    <ListContainer>
      <ListWrapper>
        {data.map((item, key) => (
          <ListItem key={key}>
            {item.type === BONUS_SK ? (
              <BonusImage />
            ) : (
              <Image
                src={item.payment_category_image}
                radius={
                  item.payment_category_name === "KBZ" ? "none" : "circle"
                }
              />
            )}
            <Wrapper>
              <ItemText>
                {item.type === BONUS_SK
                  ? t("wallet.transactionHistoryBonusType", {
                    bonus_type: item.bonus_type.replaceAll('-bonus', ''),
                  })
                  : `${item.type === WITHDRAW_SK
                    ? t("wallet.walletWithdraw")
                    : t("wallet.walletTopUp")
                  } ${t("common.to")} ${item.num}`}
              </ItemText>
              <DateText>
                {moment.unix(item.created_at).format(dateFormat)}
              </DateText>
              {item.trx_num && <DateText>{`PIN: ${item.trx_num}`}</DateText>}
              {item.type === BONUS_SK && item.bonus_expired && (
                <ExpiredContainer>
                  <ExpiredText>{t("wallet.expiredOn")}</ExpiredText>
                  <DateText>
                    {moment.unix(item.bonus_expired).format(dateFormat)}
                  </DateText>
                </ExpiredContainer>
              )}
            </Wrapper>
            <Wrapper>
              <AmountText>{`${getFormattedNumber(
                item.amount
              )} Ks.`}</AmountText>
              {item.type !== BONUS_SK && (
                <StatusText status={item.status}>
                  {getStatus(item.status)}
                </StatusText>
              )}
              {item.type === BONUS_SK && item.bonus_expired && (
                <BonusStatusText status={item.remaining_bonus === 0}>
                  {getUseOrNotUse(item.remaining_bonus === 0)}
                </BonusStatusText>
              )}
            </Wrapper>
          </ListItem>
        ))}
        {!loading && data.length === 0 && <EmptyCard minHeight={430} />}
        {loading && <Loader />}
      </ListWrapper>
      <SellAllWrapper>
        <Button onClick={goToTransactions} type="primary">
          {t("wallet.walletSeeAll")}
        </Button>
      </SellAllWrapper>
    </ListContainer>
  );

  // const renderBottom = () => (
  //   <Bottom>
  //     <BottomImage
  //       src={ads?.image}
  //       onClick={() => window.open(ads?.url, "_blank")}
  //     />
  //   </Bottom>
  // );

  return (
    <RootContainer>
      <Topbar
        title={t("wallet.walletTitle")}
        transparent={true}
        rightIcon={<RefreshIcon onClick={refresh} />}
        goBack={goBack}
      />
      <Container>
        {renderTop()}
        <Actions />
        <RecentHistoryTitle>
          {t("wallet.walletRecentHistory")}
        </RecentHistoryTitle>
        <List />
      </Container>
      {/* {renderBottom()} */}
    </RootContainer>
  );
};

export default Wallet;
